import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const ArrowsRight: FC<IIconsProps> = ({
  color,
  size = IconScale.S,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size || 16}
      height={size || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9992 8.00193L11 8.00116L6.33148 3.33265L5 4.66413L8.33774 8.00188L5.00313 11.3365L6.33462 12.668L10.9999 8.00264L10.9992 8.00193Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowsRight;
